var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLucky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 69,
    viewBox: "0 0 61 69",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2991 35.7599C23.1586 33.4582 20.4668 30.2593 20.4668 26.0851V7.63269C20.4668 6.989 20.9349 6.44284 21.5591 6.34531C24.4265 5.89668 30.7464 4.10216 35.2133 0.552126C35.6814 0.181518 36.3251 0.181518 36.7738 0.552126C41.2406 4.10216 47.58 5.89668 50.4279 6.34531C51.0521 6.44284 51.5202 6.989 51.5202 7.63269V26.0851C51.5202 35.1942 38.7439 39.622 36.3641 40.3827",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2667 53.5491C22.3148 54.5244 25.2212 55.4216 27.3473 56.3969C27.6399 56.5335 27.9325 56.592 28.2446 56.592C31.9702 56.5139 35.4423 56.2214 39.1094 55.8507C40.1237 55.7532 40.8844 54.934 40.943 53.9197V53.8027C41.0795 51.384 39.285 49.3554 36.8857 49.1408C35.0717 48.9848 33.3942 48.6922 31.7166 48.4776C31.3265 48.4191 30.9559 48.263 30.6828 48.0095C26.7426 44.7325 23.3291 41.8262 18.7452 41.8262C14.1613 41.8262 10.2991 43.6987 7.33423 46.7026C6.51498 47.5413 5.55919 48.2435 4.48636 48.6922C2.98441 49.2968 1.36542 50.0381 0 50.4867",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6336 48.4976C46.2669 47.4443 49.0562 46.2154 51.9821 44.6745C54.4789 43.3871 57.5608 43.9528 59.4334 46.0594L59.4724 46.1179C60.2916 47.0347 60.1356 48.4391 59.1408 49.1413C49.5244 56.1048 35.324 66.5403 30.5451 66.7549C25.7661 66.9695 17.3981 65.1554 10.7466 64.1997C10.2784 64.1411 9.81028 64.1997 9.42016 64.4727C7.5671 65.565 5.38244 67.067 3.58789 68.0618",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5913 18.5931C43.0738 18.3201 44.3611 17.7349 44.7708 16.4475C45.6875 13.6192 42.0789 12.4489 42.0789 12.4489C42.0789 12.4489 40.9086 8.84031 38.0802 9.75708C36.7928 10.1667 36.2077 11.4541 35.9346 12.9365C35.6615 11.4541 35.0763 10.1667 33.7889 9.75708C30.9606 8.84031 29.7902 12.4489 29.7902 12.4489C29.7902 12.4489 26.1816 13.6192 27.0984 16.4475C27.508 17.7349 28.7954 18.3201 30.2779 18.5931C28.7954 18.8662 27.508 19.4514 27.0984 20.7388C26.1816 23.5671 29.7902 24.7374 29.7902 24.7374C29.7902 24.7374 30.9606 28.346 33.7889 27.4292C35.0763 27.0196 35.6615 25.7322 35.9346 24.2498C36.2077 25.7322 36.7928 27.0196 38.0802 27.4292C40.9086 28.346 42.0789 24.7374 42.0789 24.7374C42.0789 24.7374 45.6875 23.5671 44.7708 20.7388C44.3611 19.4514 43.0738 18.8662 41.5913 18.5931Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0477 26.7875C36.4625 29.8109 34.8045 31.6835 32.4248 32.7173C32.3858 32.7173 32.3468 32.7563 32.3078 32.7563C32.2102 32.7758 32.1322 32.7953 32.0347 32.7953C31.6446 32.7953 31.2739 32.5807 31.1179 32.1906C30.9033 31.6835 31.1179 31.0983 31.625 30.8837C33.1855 30.201 34.6485 29.1672 35.0191 26.5535",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9515 24.2522C35.659 22.3211 35.815 20.5266 35.815 20.5266",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2949 18.5941C32.226 18.3015 34.0206 18.4576 34.0206 18.4576",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9492 12.9568C36.2418 14.8878 36.0858 16.6824 36.0858 16.6824",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.587 18.595C39.6559 18.8876 37.8613 18.7315 37.8613 18.7315",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucky);
export default __webpack_public_path__ + "static/media/lucky.11883e60.svg";
export { ForwardRef as ReactComponent };